import getVideoId from 'get-video-id'

const isVimeo = url => {
  const video = getVideoId(url)
  return video && video.service === 'vimeo'
}

export default isVimeo
